export default __webpack_public_path__ + "static/media/fcm-admin.b0676a2c.png";